import React from 'react';
import { ELEMENT_MENTION_INPUT, MentionPlugin, createPluginFactory, isSelectionInMentionInput } from '@udecode/plate';
import { withMemory } from './withMemory';
import { memoryOnKeyDownHandler } from './mentionOnKeyDownHandler';
import { MemoryElement } from './MemoryElement';

export const MEMORY_PLUGIN_NAME = 'variable';

const MemoMentionElement = ({ ...props }) => {
  return <MemoryElement {...props} renderLabel={(element: any) => element.value || element.attributes['data-value']} />;
};

const createMemorySelectorPlugin = createPluginFactory<MentionPlugin>({
  key: MEMORY_PLUGIN_NAME,
  component: MemoMentionElement,

  isElement: true,
  isInline: true,
  isVoid: true,

  withOverrides: withMemory,
  handlers: {
    onKeyDown: memoryOnKeyDownHandler({ query: isSelectionInMentionInput }),
  },

  options: {
    trigger: '/',
    createMentionNode: item => {
      return { value: item.text, 'data-value': item.text, children: [{ text: `{{${item.text}}}` }] };
    },
  },

  plugins: [
    {
      key: ELEMENT_MENTION_INPUT,
      isElement: true,
      isInline: true,
    },
  ],
  then: (editor, { key }) => {
    return {
      options: {
        id: key,
      },
    };
  },
});

export default createMemorySelectorPlugin;
